import CopyFieldIcon from "components/CopyField/Icon";
import Box from "ds/components/Box";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableSessionIdCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "id">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Box direction="row" align="center" gap="small">
        <TableCellText>{session.id}</TableCellText>
        <CopyFieldIcon title="Copy" value={session.id} />
      </Box>
    </TableSimpleCell>
  );
};

export default SessionsTableSessionIdCell;
